import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const addSectionStyle: StyleRulesCallback = () => ({
  root: {
    textAlign: 'center',
    padding: '25px 25px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) !important',
    display: 'flex',
  },
  topTitle: {
    textAlign: 'left',
  },
  spacing: {
    flexGrow: 1,
    marginRight: 20,
    minWidth: 220,
  },
  checkboxes: {
    textAlign: 'left',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 320,
  },
  accessGroup: {
    textAlign: 'left',
    padding: '8px 0',
  },
  accessLegend: {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: 4,
  },
  // was `float: 'right'`, which let the buttons ride up beside the last
  // checkbox instead of sitting under it
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 16,
  },
});

export default addSectionStyle;
